import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircleIcon, AlertCircleIcon, XCircleIcon, ClockIcon, ZapIcon } from 'lucide-react';
import StepsGuide from './StepsGuide';
const CategoryCard = ({
  title,
  count,
  icon,
  color,
  linkTo,
  description,
  delay
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay
  }} data-id="element-81">
      <Link to={linkTo} className="block" data-id="element-82">
        <motion.div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow relative overflow-hidden border border-gray-100" whileHover={{
        scale: 1.02,
        transition: {
          duration: 0.2
        }
      }} whileTap={{
        scale: 0.98
      }} data-id="element-83">
          <div className={`absolute top-0 left-0 right-0 h-1 ${color}`} data-id="element-84" />
          <div className="flex items-start justify-between relative" data-id="element-85">
            <div data-id="element-86">
              <h3 className="text-lg font-semibold text-gray-800" data-id="element-87">{title}</h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-88">{description}</p>
            </div>
            <motion.div className={`p-3 rounded-full ${color}`} whileHover={{
            rotate: 360
          }} transition={{
            duration: 0.5
          }} data-id="element-89">
              {icon}
            </motion.div>
          </div>
          <div className="mt-4 relative" data-id="element-90">
            <motion.span className="text-3xl font-bold text-gray-900" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: delay + 0.2
          }} data-id="element-91">
              {count}
            </motion.span>
            <span className="text-gray-500 text-sm ml-1" data-id="element-92">products</span>
          </div>
        </motion.div>
      </Link>
    </motion.div>;
};
const Dashboard = ({
  productCounts
}) => {
  const totalProducts = Object.values(productCounts).reduce((a, b) => a + b, 0);
  const progress = productCounts.perfectMatch / totalProducts * 100;
  return <div className="max-w-7xl mx-auto px-4 py-6" data-id="element-93">
      <motion.div className="mb-4" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3
    }} data-id="element-94">
        <h1 className="text-xl font-bold text-gray-800" data-id="element-95">Link your Products</h1>
        <div className="flex items-center mt-1" data-id="element-96">
          <p className="text-sm text-gray-600" data-id="element-97">
            Connect your Shopify products to Amazon listings
          </p>
          <div className="ml-3 bg-gray-100 rounded-full px-2 py-0.5 text-xs" data-id="element-98">
            {progress.toFixed(0)}% Complete
          </div>
        </div>
      </motion.div>
      <StepsGuide data-id="element-99" />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-100">
        <CategoryCard title="Perfect Match" count={productCounts.perfectMatch} icon={<CheckCircleIcon className="h-6 w-6 text-white" data-id="element-102" />} color="bg-green-500" linkTo="/products/perfect-match" description="Products with exact matches" delay={0.2} data-id="element-101" />
        <CategoryCard title="Potential Match" count={productCounts.potentialMatch} icon={<AlertCircleIcon className="h-6 w-6 text-white" data-id="element-104" />} color="bg-yellow-500" linkTo="/products/potential-match" description="Products with possible matches" delay={0.3} data-id="element-103" />
        <CategoryCard title="No Match" count={productCounts.noMatch} icon={<XCircleIcon className="h-6 w-6 text-white" data-id="element-106" />} color="bg-red-500" linkTo="/products/no-match" description="Products without matches" delay={0.4} data-id="element-105" />
        <CategoryCard title="Skipped" count={productCounts.skipped} icon={<ClockIcon className="h-6 w-6 text-white" data-id="element-108" />} color="bg-purple-500" linkTo="/products/skipped" description="Products to review later" delay={0.5} data-id="element-107" />
      </div>
      <div className="mt-6" data-id="element-109">
        <Link to="/animation-variations" data-id="element-110">
          <motion.div className="bg-white rounded-lg shadow-md p-4 border border-blue-100 flex items-center justify-between hover:shadow-lg transition-shadow" whileHover={{
          scale: 1.01,
          transition: {
            duration: 0.2
          }
        }} whileTap={{
          scale: 0.99
        }} data-id="element-111">
            <div className="flex items-center" data-id="element-112">
              <div className="p-2 rounded-full bg-blue-100 mr-3" data-id="element-113">
                <ZapIcon className="h-5 w-5 text-blue-600" data-id="element-114" />
              </div>
              <div data-id="element-115">
                <h3 className="font-medium text-gray-900" data-id="element-116">
                  Animation Variations
                </h3>
                <p className="text-sm text-gray-500" data-id="element-117">
                  Test different animation styles for product linking
                </p>
              </div>
            </div>
            <div className="text-blue-600 text-sm font-medium" data-id="element-118">
              View Animations
            </div>
          </motion.div>
        </Link>
      </div>
    </div>;
};
export default Dashboard;